import * as z from "zod";

export const ElementType = z.enum(["Title", "Subtitle", "Description", "ContentImage"]); 